<ppl-box-section title="Your mobile devices"
                 i18n-title="@@Your_mobile_devices">
  <div class="description"
       i18n="@@List_of_mobile_devices_where_you_are_currently_signed_in_with_QR_Code:">
    List of mobile devices where you are currently signed in with QR Code:
  </div>

  <ng-container *ngIf="sessions$ | async; let sessions">
    <ppl-loading *ngIf="sessions.state === AsyncState.FETCHING"
                 [large]="true"
                 [inverse]="true"></ppl-loading>

    <div *ngIf="sessions.state === AsyncState.FETCHED">
      <ppl-mobile-sign-in-session-item *ngFor="let session of sessions.value; trackBy: trackById"
                                       [session]="session"
                                       (signOutClick)="onSignOutClick(session.id)"></ppl-mobile-sign-in-session-item>

      <div *ngIf="sessions.value.length === 0"
           class="no-sessions"
           i18n="@@You_have_no_signed_in_mobile_devices.">
        You have no signed in mobile devices.
      </div>
    </div>

    <div *ngIf="sessions.state === AsyncState.ERROR">
      Error
    </div>
  </ng-container>
</ppl-box-section>
